export const USER_ACCESS_TOKEN = 'token';
export const USER_REFRESH_TOKEN = 'refresh_token';
export const ACTIVE_APPLICATION_ID = 'active_application';
export const ACTIVE_INTAKE_FORM_ID = 'active_intake_form';
export const AMOUNT_OF_ATTEMPTS_RESENDING_OTP_SMS =
  'amount_of_attempts_resending_otp_sms';
export const AMOUNT_OF_ATTEMPTS_RESENDING_OTP_EMAIL =
  'amount_of_attempts_resending_otp_email';
export const TIME_OFFSET = 'timeOffset';

// Access Token
export function getAccessToken(): string {
  return localStorage.getItem(USER_ACCESS_TOKEN) || '';
}

export function setAccessToken(token: string) {
  localStorage.setItem(USER_ACCESS_TOKEN, token);
}

// Refresh Token
export function getRefreshToken(): string {
  return localStorage.getItem(USER_REFRESH_TOKEN) || '';
}

export function setRefreshToken(token: string) {
  localStorage.setItem(USER_REFRESH_TOKEN, token);
}

// setAuthenticationTokens
export function setAuthenticationTokens(
  accessToken: string,
  refreshToken: string,
) {
  localStorage.setItem(USER_ACCESS_TOKEN, accessToken);
  localStorage.setItem(USER_REFRESH_TOKEN, refreshToken);
}

// Active Application
export function getActiveApplicationId(): string {
  return localStorage.getItem(ACTIVE_APPLICATION_ID) || '';
}

export function setActiveApplicationId(applicationId: string | null) {
  if (applicationId == null) {
    localStorage.removeItem(ACTIVE_APPLICATION_ID);
  } else {
    localStorage.setItem(ACTIVE_APPLICATION_ID, applicationId);
  }
}

//  Active Intake Form
export function getActiveIntakeFormId(): string {
  return localStorage.getItem(ACTIVE_INTAKE_FORM_ID) || '';
}

export function setActiveIntakeFormId(formId: string | null) {
  if (formId == null) {
    localStorage.removeItem(ACTIVE_INTAKE_FORM_ID);
  } else {
    localStorage.setItem(ACTIVE_INTAKE_FORM_ID, formId);
  }
}

// Attempts for Email OTP
export function getAttemptsOfResendingEmailOTP(): number {
  const val = localStorage.getItem(AMOUNT_OF_ATTEMPTS_RESENDING_OTP_EMAIL);
  return val ? parseInt(val, 10) || 0 : 0;
}

export function setAttemptsOfResendingEmailOTP(amount: number) {
  localStorage.setItem(AMOUNT_OF_ATTEMPTS_RESENDING_OTP_EMAIL, String(amount));
}

// Attempts for SMS OTP
export function getAttemptsOfResendingSmsOTP(): number {
  const val = localStorage.getItem(AMOUNT_OF_ATTEMPTS_RESENDING_OTP_SMS);
  return val ? parseInt(val, 10) || 0 : 0;
}

export function setAttemptsOfResendingSmsOTP(amount: number) {
  localStorage.setItem(AMOUNT_OF_ATTEMPTS_RESENDING_OTP_SMS, String(amount));
}

export function setTimeOffset(serverTime: number) {
  const timeOffset = serverTime * 1000 - Date.now();
  const localTimeOffset = getTimeOffset();

  if (!localTimeOffset || Number(localTimeOffset) !== timeOffset) {
    localStorage.setItem(TIME_OFFSET, String(timeOffset));
  }
}

export function getTimeOffset() {
  return localStorage.getItem(TIME_OFFSET) || '';
}

// Clear
export function clearLocalStorage() {
  localStorage.clear();
}
